<template>
  <span
    v-if="!items.length"
    class="inline-block size-2.5 rounded-full bg-green-500"
    title="Kontent uzupełniony"
    aria-label="Kontent uzupełniony"
  />
  <fixed-tooltip v-else>
    <span
      class="inline-block size-2.5 cursor-help rounded-full bg-amber-500"
      tabindex="0"
      :title="titleText"
      aria-label="Brakujący kontent"
    />
    <template #content>
      <p class="font-medium">
        Do uzupełnienia:
      </p>
      <ul class="mt-1 list-disc pl-4">
        <li
          v-for="item in items"
          :key="item"
        >
          {{ item }}
        </li>
      </ul>
    </template>
  </fixed-tooltip>
</template>

<script setup>
import { computed } from 'vue';
import FixedTooltip from '@/Shared/FixedTooltip.vue';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const titleText = computed(() => {
  if (!props.items.length) return '';
  return `Do uzupełnienia: ${props.items.join(', ')}`;
});
</script>
